import { connect }          from 'react-redux'
import PlaceMarker          from '../PlaceMarker';
import { openWindow }       from '../../../actions/MapAction';

const mapStateToProps = (state) => {
    return {
        hasGoogle  : state.appHeader.google,
        theme      : state.assets.items.theme,
        pin        : state.assets.items.pin,
        geo        : state.geo,
        map        : state.map
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        openWindow: (window) => {
            dispatch(openWindow(window));
        }
    }
};

const PlaceMarkerContainer = connect(mapStateToProps, mapDispatchToProps)(PlaceMarker);

export default PlaceMarkerContainer;


// WEBPACK FOOTER //
// ./src/components/Map/containers/PlaceMarkerContainer.js